import PropTypes from 'prop-types';
import React from 'react';

import { CalendarItem } from '$partials/listings';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleCalendarBlock = ({
    heading = null,
    calendarItems,
}) => {
    return (
        <section className='relative'>
            <section className='layout-container'>
                <div className='layout-grid-negative-gutter md:flex'>
                    <div className='md:w-1/12 layout-grid-col-padding' />
                    <div className='md:flex md:w-11/12 layout-grid-col-padding'>
                        {heading && (
                            <h2 className='type-style-1 py-40 md:pb-60 md:pt-100'>{heading}</h2>
                        )}
                    </div>
                </div>
            </section>
            <section className='hidden md:block layout-container'>
                <div className='layout-grid-negative-gutter md:flex md:pb-30'>
                    <div className='md:w-1/12 layout-grid-col-padding' />
                    <div className='md:flex md:w-11/12'>
                        <p className='type-style-4 w-4/11 layout-grid-col-padding'>Title</p>
                        <p className='type-style-4 w-2/11 layout-grid-col-padding'>Start Date</p>
                        <p className='type-style-4 w-2/11 layout-grid-col-padding'>Location</p>
                        <p className='type-style-4 w-2/11 layout-grid-col-padding'>Type</p>
                    </div>
                </div>
            </section>

            {calendarItems?.map((item, idx)  => {
                return (
                    <CalendarItem
                        { ...item.page }
                        key={idx} />
                );
            })}
        </section>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    calendarItems: PropTypes.array.isRequired,
    heading: PropTypes.string
};

ModuleCalendarBlock.propTypes = propTypes;

export default ModuleCalendarBlock;
